<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.2593 18.2765C14.07 17.5209 13.4629 17.2253 13.0102 17.2253C12.557 17.2253 11.9499 17.5209 10.7612 18.2765C9.96379 18.7851 4.37859 20.3076 6.80838 8.63049C6.98502 7.78636 7.20797 6.29107 7.20797 5.98229C7.20797 5.68986 7.31695 4.74946 8.40447 5.69259C9.49291 6.63571 10.5795 9.8883 11.124 11.6038C11.6135 13.1454 11.8973 12.5442 12.1166 12.2913C12.2097 12.1846 12.5934 11.9371 12.9925 11.9371C13.3921 11.9371 13.8112 12.1846 13.9038 12.2913C14.1227 12.5442 14.4065 13.1454 14.896 11.6038C15.4414 9.8883 16.5275 6.63571 17.616 5.69259C18.7035 4.74946 18.8134 5.68986 18.8134 5.98229C18.8134 6.29107 19.0359 7.78636 19.2125 8.63049C21.6418 20.3076 16.0566 18.7851 15.2593 18.2765ZM13.0002 2C7.47724 2 3 6.47724 3 11.9998C3 17.5228 7.47724 22 13.0002 22C18.5232 22 23 17.5228 23 11.9998C23 6.47724 18.5232 2 13.0002 2Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgTHYROIDNewsFeed',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>